import React from 'react';
import classnames from 'clsx';
import PropTypes from 'prop-types';

import { Pill } from 'ui-components/components/pill';

import style from './style.module.css';

const defaultLabelFormatter = (label) => label;

export const PillBank = ({ selectedItems, labelFormatter = defaultLabelFormatter, onUpdate, className = '' }) => {
  return (
    <div className={classnames(style['pill-bank'], className)}>
      {selectedItems.map((selectedItem) => (
        <Pill
          key={selectedItem}
          className={style.pill}
          label={labelFormatter(selectedItem)}
          onRemove={() => onUpdate(selectedItems.filter((item) => item !== selectedItem))}
        />
      ))}
    </div>
  );
};

PillBank.propTypes = {
  selectedItems: PropTypes.array.isRequired,
  onUpdate: PropTypes.func.isRequired,
  labelFormatter: PropTypes.func,
  className: PropTypes.string,
};
